import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { SingleWaveDropPosition } from "@/components/waves/drop/SingleWaveDropPosition";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ImageScale } from "@/helpers/image.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { getDropPreviewImageUrl } from "@/helpers/waves/drop.helpers";
import Link from "next/link";
import React, { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import MyStreamWaveMyVoteInput from "./MyStreamWaveMyVoteInput";
import MyStreamWaveMyVoteVotes from "./MyStreamWaveMyVoteVotes";
interface MyStreamWaveMyVoteProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isChecked?: boolean | undefined;
  readonly onToggleCheck?: ((dropId: string) => void) | undefined;
  readonly isResetting?: boolean | undefined;
}
const MyStreamWaveMyVote: React.FC<MyStreamWaveMyVoteProps> = t0 => {
  const $ = _c(92);
  const {
    drop,
    onDropClick,
    isChecked: t1,
    onToggleCheck,
    isResetting: t2
  } = t0;
  const isChecked = t1 === undefined ? false : t1;
  const isResetting = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[0] = drop.parts;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const artWork = t3;
  let t4;
  if ($[2] !== drop.metadata) {
    t4 = getDropPreviewImageUrl(drop.metadata);
    $[2] = drop.metadata;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const previewImageUrl = t4;
  let t5;
  if ($[4] !== drop || $[5] !== onDropClick) {
    t5 = () => {
      if (window.getSelection()?.toString()) {
        return;
      }
      onDropClick(drop);
    };
    $[4] = drop;
    $[5] = onDropClick;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleClick = t5;
  let t6;
  if ($[7] !== drop.id || $[8] !== onToggleCheck) {
    t6 = e => {
      e.stopPropagation();
      if (onToggleCheck) {
        onToggleCheck(drop.id);
      }
    };
    $[7] = drop.id;
    $[8] = onToggleCheck;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleCheckboxClick = t6;
  const t7 = drop.id;
  const t8 = `tw-cursor-pointer tw-rounded-xl tw-border tw-border-solid tw-bg-iron-950 tw-px-5 tw-py-4 tw-shadow-md tw-transition-all tw-duration-300 tw-@container desktop-hover:hover:tw-shadow-lg ${isChecked ? "tw-border-primary-400" : "tw-border-iron-800 desktop-hover:hover:tw-border-iron-700"}`;
  const t9 = `tw-flex tw-size-5 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid ${isChecked ? "tw-border-primary-400 tw-bg-primary-400/20" : "tw-border-iron-600 tw-bg-iron-800"} tw-cursor-pointer tw-shadow-sm tw-transition-all tw-duration-200 hover:tw-shadow-md`;
  let t10;
  if ($[10] !== isChecked) {
    t10 = isChecked && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-4 tw-text-primary-400"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 0 1 1.04-.208Z" clipRule="evenodd" /></svg>;
    $[10] = isChecked;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== handleCheckboxClick || $[16] !== t11) {
    t12 = <div className="tw-mr-1 tw-flex-shrink-0 tw-self-start" onClick={handleCheckboxClick}>{t11}</div>;
    $[15] = handleCheckboxClick;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== artWork || $[19] !== previewImageUrl) {
    t13 = artWork && <MediaDisplay media_mime_type={artWork.mime_type} media_url={artWork.url} imageScale={ImageScale.AUTOx450} previewImageUrl={previewImageUrl} disableMediaInteraction={true} />;
    $[18] = artWork;
    $[19] = previewImageUrl;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <div className="tw-relative tw-min-h-[106px] tw-min-w-[106px] tw-flex-shrink-0 tw-overflow-hidden tw-bg-iron-800 @xs:tw-h-56 @xs:tw-w-full @sm:tw-mb-2 @sm:tw-h-56 @sm:tw-w-full @md:tw-size-[106px]"><div className="tw-relative tw-flex tw-h-full tw-w-full tw-transform tw-items-center tw-justify-center tw-duration-300 tw-ease-out desktop-hover:hover:tw-scale-105"><div className="tw-absolute tw-inset-0 tw-z-[1]">{t13}</div></div></div>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const t15 = artWork?.mime_type;
  let t16;
  if ($[23] !== drop.id || $[24] !== t15) {
    t16 = <MediaTypeBadge mimeType={t15} dropId={drop.id} size="sm" />;
    $[23] = drop.id;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== drop.title) {
    t17 = <h3 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-50">{drop.title}</h3>;
    $[26] = drop.title;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-2">{t16}{t17}</div>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== drop.rank) {
    t19 = drop.rank && <SingleWaveDropPosition rank={drop.rank} />;
    $[31] = drop.rank;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18 || $[34] !== t19) {
    t20 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3">{t18}{t19}</div>;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== drop.author.pfp) {
    t21 = <div className="tw-relative tw-size-6 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10">{drop.author.pfp ? <img src={drop.author.pfp} alt="Profile" className="tw-h-full tw-w-full tw-bg-iron-800 tw-object-contain" /> : <div className="tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-white/10" />}</div>;
    $[36] = drop.author.pfp;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const t22 = drop.author.handle ?? drop.author.id;
  const t23 = `/${drop.author.handle}`;
  let t24;
  if ($[38] !== drop.author.handle) {
    t24 = e_0 => {
      e_0.stopPropagation();
      e_0.preventDefault();
      window.open(`/${drop.author.handle}`, "_blank");
    };
    $[38] = drop.author.handle;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== drop.author.handle || $[41] !== t23 || $[42] !== t24) {
    t25 = <Link href={t23} onClick={t24} className="tw-truncate tw-text-md tw-font-medium tw-text-iron-200 tw-no-underline tw-transition-colors tw-duration-200 desktop-hover:hover:tw-text-opacity-80 desktop-hover:hover:tw-underline">{drop.author.handle}</Link>;
    $[40] = drop.author.handle;
    $[41] = t23;
    $[42] = t24;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t22 || $[45] !== t25) {
    t26 = <UserProfileTooltipWrapper user={t22}>{t25}</UserProfileTooltipWrapper>;
    $[44] = t22;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  const t27 = drop.author.level || 0;
  let t28;
  if ($[47] !== t27) {
    t28 = <UserCICAndLevel level={t27} size={UserCICAndLevelSize.SMALL} />;
    $[47] = t27;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t21 || $[50] !== t26 || $[51] !== t28) {
    t29 = <div className="tw-mt-4 tw-flex tw-items-center tw-gap-2">{t21}{t26}{t28}</div>;
    $[49] = t21;
    $[50] = t26;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== drop) {
    t30 = <div onClick={_temp}><MyStreamWaveMyVoteVotes drop={drop} /></div>;
    $[53] = drop;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== drop.id || $[56] !== drop.top_raters) {
    t31 = drop.top_raters?.slice(0, 3).map(voter => <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp2} data-tooltip-id={`my-vote-voter-${drop.id}-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`my-vote-voter-${drop.id}-${voter.profile.handle}`} place="top" offset={8} opacity={1} style={{
        padding: "4px 8px",
        background: "#37373E",
        color: "white",
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "6px",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
        zIndex: 99999,
        pointerEvents: "none"
      }}>{voter.profile.handle} -{" "}{formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>);
    $[55] = drop.id;
    $[56] = drop.top_raters;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t31) {
    t32 = <div className="tw-flex tw-items-center -tw-space-x-2">{t31}</div>;
    $[58] = t31;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== drop.raters_count) {
    t33 = formatNumberWithCommas(drop.raters_count);
    $[60] = drop.raters_count;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  const t34 = drop.raters_count === 1 ? "voter" : "voters";
  let t35;
  if ($[62] !== t34) {
    t35 = <span className="tw-font-normal tw-text-iron-500">{t34}</span>;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t33 || $[65] !== t35) {
    t36 = <span className="tw-text-sm tw-font-semibold tw-text-iron-200">{t33}{" "}{t35}</span>;
    $[64] = t33;
    $[65] = t35;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t32 || $[68] !== t36) {
    t37 = <div className="tw-flex tw-items-center tw-gap-2">{t32}{t36}</div>;
    $[67] = t32;
    $[68] = t36;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t30 || $[71] !== t37) {
    t38 = <div className="tw-flex tw-items-center tw-gap-x-6">{t30}{t37}</div>;
    $[70] = t30;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== drop || $[74] !== isResetting) {
    t39 = <div onClick={_temp3}><MyStreamWaveMyVoteInput drop={drop} isResetting={isResetting} /></div>;
    $[73] = drop;
    $[74] = isResetting;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== t38 || $[77] !== t39) {
    t40 = <div className="tw-mt-3.5 tw-flex tw-flex-col tw-justify-between tw-gap-4 @lg:tw-flex-col @[42rem]:tw-flex-row xl:tw-mt-3">{t38}{t39}</div>;
    $[76] = t38;
    $[77] = t39;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  let t41;
  if ($[79] !== t20 || $[80] !== t29 || $[81] !== t40) {
    t41 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t20}{t29}{t40}</div>;
    $[79] = t20;
    $[80] = t29;
    $[81] = t40;
    $[82] = t41;
  } else {
    t41 = $[82];
  }
  let t42;
  if ($[83] !== t12 || $[84] !== t14 || $[85] !== t41) {
    t42 = <div className="tw-flex tw-gap-4 @xs:tw-flex-col @sm:tw-flex-col @md:tw-flex-row">{t12}{t14}{t41}</div>;
    $[83] = t12;
    $[84] = t14;
    $[85] = t41;
    $[86] = t42;
  } else {
    t42 = $[86];
  }
  let t43;
  if ($[87] !== drop.id || $[88] !== handleClick || $[89] !== t42 || $[90] !== t8) {
    t43 = <div key={t7} className={t8} onClick={handleClick}>{t42}</div>;
    $[87] = drop.id;
    $[88] = handleClick;
    $[89] = t42;
    $[90] = t8;
    $[91] = t43;
  } else {
    t43 = $[91];
  }
  return t43;
};
export default MyStreamWaveMyVote;
function _temp(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_2) {
  return e_2.stopPropagation();
}
function _temp3(e_3) {
  return e_3.stopPropagation();
}